// Code generated by @hex-insights/frontend-generator; While this comment is present this file may be overwritten. If manual edits are made, remove this comment.
import { CourseSection, HomeRoomSection, MarkingSystem, ReportCardSectionPolicy } from "../../../Utilities";

export type Base = {
	nameSuffix: ReportCardSectionPolicy["nameSuffix"];
	usesDescription: ReportCardSectionPolicy["usesDescription"];
	descriptionLabel: ReportCardSectionPolicy["descriptionLabel"];
	description: ReportCardSectionPolicy["description"];
	usesOverallMark: ReportCardSectionPolicy["usesOverallMark"];
	overallMarkLabel: ReportCardSectionPolicy["overallMarkLabel"];
	isOverallMarkManual: ReportCardSectionPolicy["isOverallMarkManual"];
	usesComment: ReportCardSectionPolicy["usesComment"];
	commentLabel: ReportCardSectionPolicy["commentLabel"];
	minCommentLength: ReportCardSectionPolicy["minCommentLength"] | null;
	maxCommentLength: ReportCardSectionPolicy["maxCommentLength"] | null;
	isForHomeRoomSection: ReportCardSectionPolicy["isForHomeRoomSection"];
	usesGeneralComments: ReportCardSectionPolicy["usesGeneralComments"];
	minGeneralComment1Length: ReportCardSectionPolicy["minGeneralComment1Length"] | null;
	maxGeneralComment1Length: ReportCardSectionPolicy["maxGeneralComment1Length"] | null;
	minGeneralComment2Length: ReportCardSectionPolicy["minGeneralComment2Length"] | null;
	maxGeneralComment2Length: ReportCardSectionPolicy["maxGeneralComment2Length"] | null;
	courseSectionID: CourseSection["id"] | null;
	homeRoomSectionID: HomeRoomSection["id"] | null;
	overallMarkingSystemID: MarkingSystem["id"] | null;
};

export type Create = Base;

export type CreateRequiredKey = Extract<keyof Create, never>;

export type CreateSubset<K extends keyof Create = keyof Create> = Pick<Create, CreateRequiredKey | K>;

export const initialCreate: Create = {
	nameSuffix: "",
	usesDescription: false,
	descriptionLabel: "",
	description: "",
	usesOverallMark: false,
	overallMarkLabel: "",
	isOverallMarkManual: false,
	usesComment: false,
	commentLabel: "",
	minCommentLength: null,
	maxCommentLength: null,
	isForHomeRoomSection: false,
	usesGeneralComments: false,
	minGeneralComment1Length: null,
	maxGeneralComment1Length: null,
	minGeneralComment2Length: null,
	maxGeneralComment2Length: null,
	courseSectionID: null,
	homeRoomSectionID: null,
	overallMarkingSystemID: null,
};

export type Detail = Base;

export type DetailSubset<K extends keyof Detail = keyof Detail> = Pick<Detail, K>;
